export function setMeta({
  title,
  description,
  image,
  url,
}: {
  title: string;
  description: string;
  image: string;
  url: string;
}) {
  const newTitle = title ? `${title} | Cartwheel` : 'Cartwheel';
  document.title = newTitle;
  document
    .querySelectorAll('.meta-title')
    .forEach((el) => el.setAttribute('content', newTitle));
  document
    .querySelectorAll('.meta-description')
    .forEach((el) => el.setAttribute('content', description));
  document
    .querySelectorAll('.meta-image')
    .forEach((el) => el.setAttribute('content', image));
  document
    .querySelectorAll('.meta-url')
    .forEach((el) => el.setAttribute('content', url));
}
